import React, { ReactNode } from 'react';
import { Element } from '@/components/card/CardBody/CardBody.styles';

export interface CardBodyProps {
  className?: string;
  children?: ReactNode;
}

const CardBody = ({ children, ...props }: CardBodyProps) => {
  return <Element>{children}</Element>;
};

export default CardBody;
